import Event from './Event.js'

class RefundCancel extends Event {
  get refund(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id===this.id)&&(rel.parent_type==='Refund'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
  get refund_expected(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id=== this.id)&&(rel.parent_type==='RefundExpected'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id===value)&&ev.id)
    } else {
      return null
    }
  }
}
export default RefundCancel
